<template>
  <!-- 户表列表 -->
  <div class="box d-flex flex-column">
    <!-- 查询条件区域 -->
    <div
      class="selector-container d-flex section-container"
      :class="{ dark: skinType }"
    >
      <SectionTitle title="任务综合查询"></SectionTitle>
      <el-form
        :inline="true"
        class="flex-grow-1 d-flex"
        :class="{ dark: skinType }"
        size="small"
      >
		<el-form-item label="项目" :class="{ 'light-label': skinType }">
		  <el-select v-model="selectProjectId">
			<el-option
			  v-for="(project, index) of projectList"
			  :key="'project-' + index"
			  :label="project.ModelName"
			  :value="project.IdStr"
			></el-option>
		  </el-select>
		</el-form-item>
        <el-form-item label="工单名称:" :class="{ 'light-label': skinType }">
          <el-input placeholder="全部" v-model="keyWords"></el-input>
        </el-form-item>
        <el-form-item label="工单类型:" :class="{ 'light-label': skinType }">
            <el-select v-model="selectTaskType">
              <el-option v-for="(type,index) of taskTypes" :key="`task-${index}`"
              :label="type.F_Name"
              :value="type.F_Code"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" style="font-size: 0.8rem" @click="chaxun"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div
      class="none-height flex-grow-1 d-flex flex-column align-items-stretch"
      style="width: 100%; background-color: white"
    >
        <el-table
          :data="tableData"
          class="table"
          stripe
                    height="100%"
          size="small"
          :class="{ dark: skinType }"
          :row-class-name="
            (...nu) => {
              return skinType ? 'dark text-white' : '';
            }
          "
        >
          <el-table-column fixed type="index" width="60" label="#">
          </el-table-column>
          <el-table-column prop="F_ProcessName" label="工单名称" min-width="250">
          </el-table-column>
					<el-table-column prop="ProjectName" label="所属项目" min-width="250">
					</el-table-column>
          <el-table-column prop="F_SchemeName" label="工单类型" width="160">
          </el-table-column>
          <el-table-column prop="F_NodeName" label="当前步骤" width="100">
          </el-table-column>
          <el-table-column prop="DangQianMaZhi" label="状态" width="100">
              <template slot-scope="scope">
                <el-tag size="mini" :type="scope.row.F_IsFinished?'info':'success'">
                  {{scope.row.F_IsFinished?'结束':'运行中'}}</el-tag>
              </template>
          </el-table-column>
          <el-table-column prop="F_CreateUserName" label="发起者" width="120">
          </el-table-column>
          <el-table-column
            prop="F_CreateDate"
            label="发起时间"
            width="150"
          >
          </el-table-column>
          <el-table-column label="操作" width="240">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                @click="handleProcess(scope.row)"
                title="流程信息"
              >流程信息</el-button>
              <el-button
                size="mini"
                type="warning"
                @click="handElectricity(scope.row)"
                title="详情"
              >详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      <div
        style="
          display: flex;
          padding: 1rem 1rem 1rem 0;
          justify-content: flex-end;
        "
        v-if="pageTotal"
        class="section-container"
        :class="{ dark: skinType }"
      >
        <el-pagination
          background
          layout="total, prev, pager, next"
          :class="{ 'text-white': skinType }"
          :current-page.sync="pageIndex"
          :total="pageTotal"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="diaTitle"  :class=" {'dark' : skinType} " :visible.sync="dialogVisible">
      <el-tabs type="border-card" :class="{'dark':skinType}">
        <el-tab-pane label="流程信息">
            <template v-if="selectProcessInfo">
              <ProcessInfo v-if="selectProcessInfo.F_SchemeName==='抢修工单'"
              :visible.sync="dialogVisible" :processInfos="tableData"
                :selectProcessInfo="selectProcessInfo"
                @data-changed="requestTaskList"></ProcessInfo>
              <MaintenanceTestProcessInfo v-else
              :visible.sync="dialogVisible" :processInfos="tableData"
                :selectProcessInfo="selectProcessInfo"
                @data-changed="requestTaskList"></MaintenanceTestProcessInfo>
              <ProcessColor></ProcessColor>
            </template>
        </el-tab-pane>
        <el-tab-pane label="流转记录">
            <ProcessTimeline :selectProcessInfo="selectProcessInfo"></ProcessTimeline>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>
<script>
import ProcessTimeline from '@/components/equipment-operational/components/dialog/process-timeline.vue';
import ProcessColor from '@/components/equipment-operational/components/dialog/process-color.vue';
import ProcessInfo from '@/components/equipment-operational/components/dialog/process-info.vue';
import MaintenanceTestProcessInfo from '@/components/equipment-operational/components/dialog/maintenance-test-process-info.vue';
import { allTasks } from '@/api/equipment-operational/index';
import SectionTitle from '@/components/utils/section-title.vue';
import mixin from '@/components/equipment-operational/mixins/index';

export default {
  components: {
    SectionTitle,
    ProcessInfo,
    ProcessColor,
    MaintenanceTestProcessInfo,
    ProcessTimeline,
  },
  mixins: [mixin],
  data() {
    return {
      selectProjectId: '',
      title: '筛选工单类型',
      selectProject: null,
      tableData: [],
      keyWords: '',
      pageIndex: 1,
      pageTotal: 0,
      pageSize: 10,
      diaTitle: '',
      dialogVisible: false,
      selectProcessInfo: null,
    };
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
    projectList() {
		  return this.$store.getters.projectList;
    },

  },
  created() {
	  this.initialData();
    this.requestTaskList();
  },
  watch: {
	  selectProjectId(val) {
      console.log('bb---------------->', this.selectProjectId);
      this.getTypeByProjectId(val);
      this.requestTaskList();
	  },

    pageIndex() {
      this.requestTaskList();
    },
    selectProject() {
      if (this.pageIndex !== 1) {
        this.pageIndex = 1;
      } else {
        this.requestTaskList();
      }
    },
  },
  methods: {
	  initialData() {
	  	const { selectProject } = this.$store.getters;
	  	if (selectProject) {
	  	  this.selectProjectId = selectProject;
	  	} else {
	  	  const [{ IdStr }] = this.projectList;
	  	  this.selectProjectId = IdStr;
	  	}
	  },
    requestTaskList() {
      allTasks({
        rows: this.pageSize,
        page: this.pageIndex,
        keyword: this.keyWords,
        schemeCode: this.selectTaskType,
        ProjectIdStr: this.selectProjectId,
      })
        .then((res) => {
          this.tableData = res.rows || [];
          this.pageTotal = res.records;
        })
        .catch(() => {
          this.tableData = [];
          this.pageTotal = 0;
        });
    },
    // 点击查询
    chaxun() {
      this.pageIndex = 1;
      this.requestTaskList();
    },
    handElectricity(task) {
      if (task.WRID) {
        this.$router.push({
          name: 'work-detail',
          params: { id: task.F_ProcessId, wId: task.WRID },
        });
      } else {
        this.$router.push({
          name: 'self-work-detail',
          params: { id: task.F_ProcessId },
        });
      }
    },
    handleProcess(task) {
      this.selectProcessInfo = task;
      console.log('this.selectProcessInfo', this.selectProcessInfo);
      this.diaTitle = '工单流程';
      this.dialogVisible = true;
    },
    handleAudit(task) {
      this.selectProcessInfo = task;
      console.log(task);
    },
  },
};
</script>
